import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type OnboardStates = {
	invisible: 'invisible';
	visible: 'visible';
	completed: 'completed';
};

type UIState = {
	previewMedia: boolean;
	loading: boolean;
	toggleMenu: boolean;
	isDrawerOpen: boolean;
	isPreviewImages: any[];
	notifications: any[];
	pullToRefresh: boolean;
	updateFound: boolean;
	isOnboardingState: keyof OnboardStates;
	isBottomNavVisible: boolean;
};

const initialState: UIState = {
	previewMedia: false,
	loading: false,
	toggleMenu: false,
	isDrawerOpen: true,
	isPreviewImages: [],
	notifications: [],
	pullToRefresh: false,
	updateFound: false,
	isOnboardingState: 'invisible',
	isBottomNavVisible: true,
};

export const UISlice = createSlice({
	name: 'UI',
	initialState,
	reducers: {
		setPreviewMedia: (state, action: PayloadAction<boolean>) => {
			state.previewMedia = action.payload;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setToggleMenu: (state, action: PayloadAction<boolean>) => {
			state.toggleMenu = action.payload;
		},
		setIsDrawerOpen: (state, action: PayloadAction<boolean>) => {
			state.isDrawerOpen = action.payload;
		},
		setPreviewImages: (state, action: PayloadAction<any[]>) => {
			state.isPreviewImages = action.payload;
		},
		setNotifications: (state, action: PayloadAction<any[]>) => {
			state.notifications = action.payload;
		},
		setPullToRefresh: (state, action: PayloadAction<boolean>) => {
			state.pullToRefresh = action.payload;
		},
		setUpdateFound: (state, action: PayloadAction<boolean>) => {
			state.updateFound = action.payload;
		},
		setIsOnBoardingState: (state, action: PayloadAction<keyof OnboardStates>) => {
			state.isOnboardingState = action.payload;
		},
		setIsBottomNavVisible: (state, action: PayloadAction<boolean>) => {
			state.isBottomNavVisible = action.payload;
		},
	},
});

export const {
	setPreviewMedia,
	setLoading,
	setToggleMenu,
	setIsDrawerOpen,
	setPreviewImages,
	setNotifications,
	setPullToRefresh,
	setUpdateFound,
	setIsOnBoardingState,
	setIsBottomNavVisible,
} = UISlice.actions;

export default UISlice.reducer;
